import { SET_DATA, SET_ITEMS, SET_ERROR } from '../mutation-types'
import axios from 'axios'

export default {
    namespaced: true,

    getters: {
        hasCrt: state => state.profile.data.features && state.profile.data.features.includes('crt'),
        crtReady: state => state.profile.data.crt && !!state.profile.data.crt.provider,
        hasLoading: state => state.profile.data.features && state.profile.data.features.includes('loading'),
        hasGtin: state => state.profile.data.features && state.profile.data.features.includes('gtin'),
        features: state => state.profile.data.features,

        suspended: state => state.profile.data.state === 3 || state.profile.data.state === 4,
        isLoaded: state => !!state.profile.data.id
    },

    modules: {
        profile: {
            namespaced: true,

            state: {
                data: { },
                error: null
            },

            mutations: {
                [SET_DATA](state, data) {
                    state.data = data
                },

                [SET_ERROR](state, error) {
                    state.error = error
                }
            },

            actions: {
                async fetch({ commit }) {
                    try {
                        let response = await axios.get('api/company/profile')
                        commit(SET_DATA, response.data)
                    } catch (error) {
                        return false
                    }

                    return true
                },

                async save({ commit, dispatch }, data) {
                    commit(SET_ERROR, null)

                    try {
                        let response = await axios.put('api/company/profile', data)
                        commit(SET_DATA, response.data)
                    } catch (error) {
                        if (error.response.status === 422) {
                            commit(SET_ERROR, error.response.data || {})
                        }

                        return false
                    }

                    return true
                },

                async enableCrt({ commit, dispatch }, attributes) {
                    commit(SET_ERROR, null)

                    try {
                        let response = await axios.post('api/company/crt', attributes)
                        commit(SET_DATA, response.data)
                    } catch (error) {
                        if (error.response.status === 422) {
                            commit(SET_ERROR, error.response.data || {})
                        }

                        return false
                    }

                    return true
                },

                async disableCrt({ commit, dispatch }) {
                    commit(SET_ERROR, null)

                    try {
                        let response = await axios.delete('api/company/crt')
                        commit(SET_DATA, response.data)
                    } catch (error) {
                        return false
                    }

                    return true
                }
            }
        },

        billing: {
            namespaced: true,

            state: {
                transactions: []
            },

            mutations: {
                [SET_ITEMS](state, items) {
                    state.transactions = items
                }
            },

            actions: {
                async fetchTransactions({ commit }) {
                    try {
                        let response = await axios.get('api/billing/transactions')
                        commit(SET_ITEMS, response.data)
                    } catch (error) {
                        return false
                    }

                    return true
                }
            }
        },

        usage: {
            namespaced: true,

            state: {
                data: {

                }
            },

            mutations: {
                [SET_DATA](state, data) {
                    state.data = data
                }
            },

            actions: {
                async fetch({ commit }) {
                    try {
                        let response = await axios.get('api/company/usage')
                        commit(SET_DATA, response.data)
                    } catch (error) {
                        return false
                    }
                }
            }
        }
    }
}
